export default function ForWhom() {
  const targetGroups = [
    {
      icon: 'ri-presentation-line',
      title: 'Menschen mit Vertriebserfahrung'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Unternehmer & Selbstständige'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Social-Media-Aktive'
    },
    {
      icon: 'ri-group-line',
      title: 'Community-Builder & Networker'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Quereinsteiger mit Motivation'
    }
  ];

  const requirements = [
    'eigenverantwortlich zu arbeiten',
    'Menschen zu verbinden',
    'dich Schritt für Schritt einzuarbeiten'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
            Eine Chance für viele – bewusst nicht nischenspezifisch
          </h2>

          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl mb-12">
            <p className="text-xl text-gray-800 mb-6 leading-relaxed">
              Unsere Tätigkeit ist nicht auf bestimmte Berufsgruppen beschränkt.
              Das ist ein riesiger Vorteil, denn:
            </p>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <p className="text-2xl font-bold text-blue-600 flex items-center gap-3">
                <span>💡</span>
                <span>Je breiter die Zielgruppe, desto größer dein potenzielles Netzwerk.</span>
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Ideal für:
          </h3>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {targetGroups.map((group, index) => (
              <div 
                key={index}
                className="bg-white border-2 border-gray-200 hover:border-blue-500 p-6 rounded-2xl transition-all duration-300 hover:shadow-lg cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-full mb-4 mx-auto">
                  <i className={`${group.icon} text-3xl text-blue-600`}></i>
                </div>
                <p className="text-center text-lg font-semibold text-gray-800">
                  {group.title}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-gray-900 text-white p-10 rounded-2xl">
            <p className="text-xl mb-6 text-center">
              Entscheidend ist nicht dein beruflicher Hintergrund, sondern deine Bereitschaft:
            </p>
            <div className="space-y-4">
              {requirements.map((req, index) => (
                <div key={index} className="flex items-center gap-4 bg-white/10 p-4 rounded-xl">
                  <span className="text-2xl">✔</span>
                  <span className="text-lg">{req}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
